/* ============================================================
   LAMPADOM — RUNTIME RENDER GUARDRAILS (TECH-6)
   Tiny, non-blocking tripwires. If a critical element fails to
   render, we fire a GTM/dataLayer event + a console.warn so a bad
   deploy is caught instead of silently shipping to paid traffic.
   Loaded with defer. Never throws (all wrapped in try/catch).
   ============================================================ */
(function () {
  function report(code, detail) {
    try {
      var payload = { event: 'render_guardrail_fail', code: code, detail: String(detail || ''), path: location.pathname };
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(payload);
      if (window.gtag) window.gtag('event', 'render_guardrail_fail', { code: code, detail: payload.detail });
      // Visible in console for QA / synthetic checks:
      (window.console && console.warn) && console.warn('[GUARDRAIL]', code, payload.detail);
    } catch (e) {}
  }

  function runChecks() {
    try {
      // 1) Hero image actually decoded (any of the common hero image classes).
      var hero = document.querySelector('.lp-hero__img, .hero-image img, [data-hero] img, .main-image-bg img');
      if (hero && (!hero.complete || hero.naturalWidth === 0)) {
        report('HERO_BLANK', 'hero image failed to decode');
      }

      // 2) Prices rendered and never a raw integer (e.g. "9240" with no currency).
      document.querySelectorAll('.money, [data-price]').forEach(function (el) {
        var txt = (el.textContent || '').trim();
        if (!txt) { report('PRICE_EMPTY', location.pathname); return; }
        if (/^\d+$/.test(txt)) report('PRICE_RAW', txt); // digits only = unformatted
      });

      // 3) An infinite-scroll loader that is still visibly "Loading…" after load.
      document.querySelectorAll('[data-infinite-loader]').forEach(function (el) {
        if (el.classList.contains('is-active')) report('LOADER_STUCK', location.pathname);
      });
    } catch (e) { /* never break the page */ }
  }

  // Run after load, then re-check once more in case of late hydration.
  addEventListener('load', function () {
    runChecks();
    setTimeout(runChecks, 4000);
  });

  // 4) Surface uncaught JS errors (e.g. a reintroduced SyntaxError-adjacent throw).
  addEventListener('error', function (e) {
    report('JS_ERROR', (e.message || '') + ' @ ' + (e.filename || ''));
  });
})();
